var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M58.516,93.092h394.968c-14.588-17.665-31.508-33.33-50.277-46.545H108.793 C90.024,59.76,73.105,75.426,58.516,93.092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M0,256c0,7.847,0.373,15.605,1.064,23.273h509.872C511.627,271.605,512,263.847,512,256 c0-7.847-0.373-15.605-1.064-23.272H1.064C0.373,240.395,0,248.153,0,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M27.916,372.363h456.168c7.538-14.746,13.686-30.317,18.276-46.544H9.64 C14.229,342.046,20.379,357.618,27.916,372.363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M108.793,465.455h294.413c18.769-13.215,35.689-28.88,50.277-46.545H58.516 C73.105,436.573,90.024,452.24,108.793,465.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M9.639,186.182h492.722c-4.59-16.228-10.739-31.8-18.277-46.545H27.916 C20.379,154.382,14.229,169.954,9.639,186.182z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M122.435,46.545h280.772C361.567,17.227,310.797,0,256,0C222.609,0,164.075,17.227,122.435,46.545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M244.87,139.637h239.214c-8.513-16.653-18.795-32.252-30.6-46.545H244.87V139.637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M244.87,232.728h266.066c-1.44-15.982-4.334-31.546-8.575-46.545H244.87V232.728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M9.64,325.819h492.72c4.242-14.998,7.136-30.563,8.576-46.545H1.064 C2.504,295.256,5.398,310.82,9.64,325.819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M58.516,418.908h394.968c11.805-14.295,22.087-29.893,30.6-46.545H27.916 C36.429,389.016,46.711,404.615,58.516,418.908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M256,512c54.797,0,105.567-17.227,147.207-46.545H108.793C150.433,494.773,201.203,512,256,512z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M9.639,186.182c-4.242,15-7.135,30.563-8.575,46.545H256V0C138.82,0,40.031,78.732,9.639,186.182z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "152.388,66.783 168.963,117.798 222.609,117.798 179.211,149.33 195.785,200.348  152.388,168.818 108.989,200.348 125.567,149.33 82.169,117.798 135.812,117.798 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLr);
export default __webpack_public_path__ + "static/media/lr.4d975f3f4bc85403dde1b156b98be9ff.svg";
export { ForwardRef as ReactComponent };